import { useHandler } from "@/hooks";
import { useInputStore, useRefInputStore } from "@/state/stores";
import { useEffect, useRef } from "react";

export function useTextChangeVisual(alwaysOn = false) {
  const textareaRef = useRefInputStore(({ inputRef }) => inputRef);
  const message = useInputStore(({ message }) => message);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined,
  );

  const updateActiveState = useHandler((isTyping: boolean) => {
    const textarea = textareaRef.current;
    if (!textarea) {
      return;
    }
    textarea.dataset.fpIsActive = String(isTyping);
  });

  useEffect(() => {
    if (alwaysOn) {
      updateActiveState(true);
      return;
    }

    clearTimeout(timeoutRef.current);

    updateActiveState(!!message);

    timeoutRef.current = setTimeout(() => {
      updateActiveState(false);
    }, 2000);

    return () => clearTimeout(timeoutRef.current);
  }, [alwaysOn, message, updateActiveState]);
}
